export const titles = [
    'Mr.',
    'Ms.',
    'Mrs.',
    'Miss'
]